import { RegisteredComponent } from "@builder.io/sdk-react";

export const sliderControlsBlockConfig: Omit<RegisteredComponent, "component"> =
  {
    name: "Slider controls",
    image:
      "https://p1.aprimocdn.net/solarwinds/01d5afb0-9b14-43c0-8432-b2fe00b482b0/Circle_arrow_Original%20file.svg",
    requiresParent: {
      message: "This component must be nested within the Slider component.",
      component: "Slider",
    },
    inputs: [
      {
        name: "prevDld",
        type: "text",
        helperText: "Analytics DLD for previous arrow",
        required: false,
        localized: false,
      },
      {
        name: "prevDlt",
        type: "text",
        helperText: "Analytics DLT for previous arrow",
        required: false,
        localized: false,
      },
      {
        name: "nextDld",
        type: "text",
        helperText: "Analytics DLD for next arrow",
        required: false,
        localized: false,
      },
      {
        name: "nextDlt",
        type: "text",
        helperText: "Analytics DLT for next arrow",
        required: false,
        localized: false,
      },
      {
        name: "dotsAnalytics",
        type: "list",
        helperText: "Per-dot analytics. Order must match number of slides.",
        subFields: [
          {
            name: "dld",
            type: "text",
          },
          {
            name: "dlt",
            type: "text",
          },
        ],
      },
    ],
  };
